import GLightbox from 'glightbox/src/js/glightbox.js';
export default (name, options) => {
  const lightbox = GLightbox({
    selector: '[data-lightbox="' + name + '"] a.lightbox-able',
    ...options
  });

  // Return focus on close.
  let focusedBefore = null;
  lightbox.on('open', () => {
    focusedBefore = document.activeElement;
  });
  lightbox.on('close', () => {
    if (focusedBefore) {
      focusedBefore.focus();
    }
  });
  return lightbox;
};